import { AnimatePresence, motion } from "framer-motion";

const GlobalSnackbar = ({ snackbar }) => {

    return (
        <AnimatePresence mode="wait">
            {snackbar.show && (
                <motion.div
                    key={snackbar.id}
                    className={`snackbar d-flex align-items-center gap-2 ${snackbar.type}`}
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{
                        duration: 0.1,
                        ease: [0.4, 0, 0.2, 1]
                    }}
                >
                    <div className="snackbar-icon px-3">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <circle cx="10" cy="10" r="9" stroke="#fff" strokeWidth="2" />
                            <path d="M10 6V11" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                            <circle cx="10" cy="14" r="1" fill="#fff" />
                        </svg>
                    </div>
                    <div className="snackbar-message">
                        {snackbar.message}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default GlobalSnackbar;
